var _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgFormats = function SvgFormats(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 92 92",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 31.5,
    cy: 31.5,
    r: 9.5,
    stroke: "currentColor",
    strokeWidth: 3
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.252 21.487h-4.974l-7.791 7.791v4.974l7.791 7.791h4.974l7.791-7.791v-4.974l-7.791-7.791ZM42.278 69.043l7.791-7.791v-4.974l-7.79-7.791",
    stroke: "currentColor",
    strokeWidth: 3
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M70.5 52.897 66.603 49H25.897L22 52.897v12.206L25.897 69h40.706l3.897-3.897V52.897Z",
    stroke: "currentColor",
    strokeWidth: 3
  })));
};
export default SvgFormats;